/* tslint:disable */
export enum PlaysRequestOrderBy {Views = "views",UserProgress = "user_progress"}
